// PluginContract_LDSPCompletion.ts
export const LDSPCompletionContract = {
  pluginName: 'LDSPCompletionPlugin',
  nodeTypes: [], // Does not register nodes
  register: () => {
    console.log('🔌 [LDSPCompletionPlugin] Initialized (no nodes to register)');
  },
};